import { Component } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
  public isOpenUiElements = false;

  menus = [
    {
      name: "My Tasks",
      link: "/tasks",
      icon: "assignment",
      show: true,
      subMenu: []
    },
  ]
  public openUiElements() {
    this.isOpenUiElements = !this.isOpenUiElements;
  }
}
// {
//   name: "dashboard",
//   link: "/dashboard",
//   icon: "dashboard",
//   show: true,
//   subMenu: []
// },